import styles from './SizeAndWeightStyles.module.css';
import { TextField } from '@material-ui/core';
import { useStyles } from '../../../Styles/styles';
import { useContext } from 'react';
import { SetupContext } from '../../../Contexts/SetupContext';
import CollapsingHeader from './CollapsingHeader/CollapsingHeader';
import DimensionNumberField from './DimensionNumberField';
import Required from './Required/Required';
import CustomAutoComplete from '../../CustomAutoComplete';
import CheckboxWithLabel from '../../CheckboxWithLabel';

const Dimensions = ({ nightMode, dimensions, handleChange, disabled, userRoles, missingFields, setPausePolling, ...props }) => {
  const { height, width, length, permitNumberFiled, commodities, dimensionViolationIdentified } = dimensions;
  const classes = useStyles();

  const { setup } = useContext(SetupContext)
  const { setupLists } = setup || {};
  const { commodities: commoditiess } = setupLists || []
  return (
    <CollapsingHeader nightMode={nightMode} title={"Dimensions"} defaultOpen={true}>
      <div className={styles['flexRow']}>
        <DimensionNumberField
          title="Height"
          totalInches={height}
          property="height"
          handleChange={handleChange}
          showMetersCalc={false}
          disabled={disabled}
        />
        <DimensionNumberField
          title="Width"
          totalInches={width}
          property="width"
          handleChange={handleChange}
          showMetersCalc={false}
          disabled={disabled}
        />
      </div>
      <div className={styles['flexRow']}>
        <DimensionNumberField
          title="Length"
          totalInches={length}
          property="length"
          handleChange={handleChange}
          showMetersCalc={false}
          disabled={disabled}
        />

      </div>
      <div className={styles['flexRow']}>
        <TextField
          name={'permitNumberFiled'}
          inputProps={{ className: disabled ? classes.disabled : "", style: { textAlign: 'center' } }}
          id="permit-number-id"
          label="Permit #"
          value={permitNumberFiled || ""}
          className={classes.matchMargin}
          disabled={disabled}
          InputLabelProps={{ shrink: true }}
          variant="outlined"
          onChange={(e) => handleChange(e.target.value, "UPDATE_PROPERTY", { property: "permitNumberFiled" })}
        />
        <Required
          required={missingFields.some(field => field?.name === "commodities")}
          message={missingFields.find(field => field?.name === "commodities")?.error}
        >
          <CustomAutoComplete
            disableClearable={true}
            autoSelect={false}
            minWidth={"250px"}
            addMargin={true}
            title={"Commodities"}
            options={commoditiess.sort((a, b) => {
              if (a?.position < b?.position) {
                return -1
              } else {
                return 1
              }
            })}
            loading={false}
            error={""}
            multiple={true}
            limitTags={3}
            value={commodities ? commoditiess?.filter(option => commodities?.some(swe => option.id === swe.id)) : []}
            name={"name"}
            stateName={"commodities"}
            updateFields={(value, stateName) => handleChange(value, 'UPDATE_PROPERTY', { property: stateName })}
            id={"commodities"}
            userRoles={userRoles}
            setPausePolling={setPausePolling}
            disabled={disabled}
            {...props}
          />
        </Required>
        <CheckboxWithLabel
          formStyle={classes.formControl}
          checked={dimensionViolationIdentified}
          onChange={(e) => handleChange(e.target.checked, 'UPDATE_PROPERTY', { property: 'dimensionViolationIdentified' })}
          stateName={"dimensionViolationIdentified"}
          title={"Dimension Violation Identified"}
          disabled={disabled}
          userRoles={userRoles}
          {...props}
        />
      </div>
    </CollapsingHeader>
  );
}



export default Dimensions;